// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#date-picker-container {
  width: 100%;
}
#date-picker-container .react-datepicker-wrapper {
  width: 100%;
}
#date-picker-container .input-container {
  position: relative;
  outline: unset;
}
#date-picker-container .input-container .calender-icon {
  position: absolute;
  right: 8px;
  top: 15px;
  background-color: transparent;
  padding: 0px 5px 0px 5px;
  display: flex;
}
#date-picker-container .input-container .calender-icon img {
  height: 16px;
}
#date-picker-container .input-container .close-icon {
  position: absolute;
  right: 12px;
  top: 17px;
  background-color: transparent;
  padding: 0px 5px 0px 5px;
  display: flex;
}
#date-picker-container .input-container .close-icon img {
  height: 12px;
}
#date-picker-container .input-container .left-calender-icon {
  left: 4px;
}
#date-picker-container .input-container input {
  width: 100%;
  border-radius: 4px;
  outline: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid var(--dee3);
  border-radius: 8px;
  height: 50px;
  padding: 13px 16px;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  line-height: 19.5px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#date-picker-container .input-container :disabled {
  background-color: #e6e6e6;
  color: #212121;
}
#date-picker-container .input-container:disabled {
  background-color: var(--4d6c);
}
#date-picker-container .input-container::placeholder {
  color: #7a7979;
}
#date-picker-container .dark-container input {
  color: var(--ffff);
  background-color: var(--4d6c);
  border: 1px solid var(--4d6c);
}
#date-picker-container .dark-container input::placeholder {
  color: #b9b9b9;
}
#date-picker-container .custom-date-header button {
  padding: 5px 10px;
  border: 0.5px solid var(--granite-gray);
  border-radius: 5px;
}
#date-picker-container .custom-date-header select {
  padding: 5px 10px 5px 5px;
  border: 0.5px solid var(--granite-gray);
}
#date-picker-container .custom-date-header select:focus-visible {
  outline: unset;
}
#date-picker-container .react-datepicker-wrapper:focus-visible,
#date-picker-container .react-datepicker__input-container:focus-visible {
  outline: unset;
}`, "",{"version":3,"sources":["webpack://./src/components/inputs/DatePicker/DatePicker.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAAE;EACE,WAAA;AAEJ;AAAE;EACE,kBAAA;EACA,cAAA;AAEJ;AAAI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,6BAAA;EACA,wBAAA;EACA,aAAA;AAEN;AADM;EACE,YAAA;AAGR;AAAI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;EACA,wBAAA;EACA,aAAA;AAEN;AADM;EACE,YAAA;AAGR;AAAI;EACE,SAAA;AAEN;AAAI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAEN;AACI;EACE,yBAAA;EACA,cAAA;AACN;AACI;EACE,6BAAA;AACN;AACI;EACE,cAAA;AACN;AAGI;EACE,kBAAA;EACA,6BAAA;EACA,6BAAA;AADN;AAEM;EACE,cAAA;AAAR;AAKI;EACE,iBAAA;EACA,uCAAA;EACA,kBAAA;AAHN;AAKI;EACE,yBAAA;EACA,uCAAA;AAHN;AAIM;EACE,cAAA;AAFR;AAQI;;EACE,cAAA;AALN","sourcesContent":["#date-picker-container {\r\n  width: 100%;\r\n  .react-datepicker-wrapper {\r\n    width: 100%;\r\n  }\r\n  .input-container {\r\n    position: relative;\r\n    outline: unset;\r\n\r\n    .calender-icon {\r\n      position: absolute;\r\n      right: 8px;\r\n      top: 15px;\r\n      background-color: transparent;\r\n      padding: 0px 5px 0px 5px;\r\n      display: flex;\r\n      img {\r\n        height: 16px;\r\n      }\r\n    }\r\n    .close-icon {\r\n      position: absolute;\r\n      right: 12px;\r\n      top: 17px;\r\n      background-color: transparent;\r\n      padding: 0px 5px 0px 5px;\r\n      display: flex;\r\n      img {\r\n        height: 12px;\r\n      }\r\n    }\r\n    .left-calender-icon {\r\n      left: 4px;\r\n    }\r\n    input {\r\n      width: 100%;\r\n      border-radius: 4px;\r\n      outline: none;\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n      border: 1px solid var(--dee3);\r\n      border-radius: 8px;\r\n      height: 50px;\r\n      padding: 13px 16px;\r\n      font-size: 14px;\r\n      font-weight: 400;\r\n      font-family: \"f-400\";\r\n      line-height: 19.5px;\r\n      white-space: nowrap;\r\n      text-overflow: ellipsis;\r\n    }\r\n\r\n    :disabled {\r\n      background-color: #e6e6e6;\r\n      color: #212121;\r\n    }\r\n    &:disabled {\r\n      background-color: var(--4d6c);\r\n    }\r\n    &::placeholder {\r\n      color: #7a7979;\r\n    }\r\n  }\r\n  .dark-container {\r\n    input {\r\n      color: var(--ffff);\r\n      background-color: var(--4d6c);\r\n      border: 1px solid var(--4d6c);\r\n      &::placeholder {\r\n        color: #b9b9b9;\r\n      }\r\n    }\r\n  }\r\n  .custom-date-header {\r\n    button {\r\n      padding: 5px 10px;\r\n      border: 0.5px solid var(--granite-gray);\r\n      border-radius: 5px;\r\n    }\r\n    select {\r\n      padding: 5px 10px 5px 5px;\r\n      border: 0.5px solid var(--granite-gray);\r\n      &:focus-visible {\r\n        outline: unset;\r\n      }\r\n    }\r\n  }\r\n  .react-datepicker-wrapper,\r\n  .react-datepicker__input-container {\r\n    &:focus-visible {\r\n      outline: unset;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
